<template>
    <div class="preloader-wrapper active" :style="`width: ${diameter}px; height: ${diameter}px;`">
        <div class="absolute border border-gray-500 rounded-full m-px"
             :style="`width: ${diameter - 2}px; height: ${diameter - 2}px;`"
        ></div>

        <div class="spinner-layer border-primary-600">
            <div class="circle-clipper left">
                <div class="circle"></div>
            </div>
            <div class="gap-patch">
                <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
                <div class="circle"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            diameter: {
                type: Number,
                default: 50,
            }
        }
    }
</script>
